import advertApi from './api/advertApi';

export const ADEVENT_LIST = 'ADEVENT/LIST';


const initialState = {
	adEvent: [],
}

export default (state = initialState, action) => {
	switch (action.type) {
		case ADEVENT_LIST:
			return {
				...state,
				adevents: action.payload
			};
		default:
			return state;
	}
};

export const adeventList = (payload = {}) => {
	return dispatch => {
		const hasQuery = payload && Object.keys(payload).length > 0;
		const queryString = hasQuery ? `?${new URLSearchParams(payload).toString()}` : '';
		return advertApi.get(`/adEvents${queryString}`).then(data => {
			dispatch({
				type: ADEVENT_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};